import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IWhiteLabelForm, WhitelabelOrganizationShow } from 'api/types';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function createWhitelableOrg(axios: AxiosInstance, orgData: IWhiteLabelForm): Promise<WhitelabelOrganizationShow> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/whitelabel-organizations`, {
    ...orgData,
    auth0_connection_type: 'auth0',
  });
  return data;
}

export default function useCreateWhitelabelOrgMutation() {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (orgData: IWhiteLabelForm) => createWhitelableOrg(axios, orgData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['Whitelabel Organization'],
      });
    },
  });
}
